export default __webpack_public_path__ + "static/media/PKD.7508cc77.png";